export default __webpack_public_path__ + "static/media/prevDate.280e2d5e.svg";